import * as React from 'react'
import {Feature} from '../../../core/models'
import {IFeatureLayerInfo} from '../../../core/interfaces/models'
import appConfig from '../../../reducers/appConfig'
import {ServiceHub} from '../../../core/ServiceHub'
import {connect} from 'react-redux'
import {IAppStore} from '../../../interfaces/reducers'
import {IFeatureLayerInfos} from '../../../core/interfaces/reducers'
import OverlayLoader from '../../../core/components/Loading/OverlayLoading'
import {getPlanName} from '../../../helpers/regHelper'

interface ParentProps {
  feature: Feature
  layerInfo: IFeatureLayerInfo
  continueDelete: (feature: Feature) => void
}

interface OwnProps {
  layerInfos: IFeatureLayerInfos
}

interface DispatchProps {}

type Props = OwnProps & ParentProps & DispatchProps

interface State {
  newerPlans: Feature[]
  selectedNewerPlan?: Feature
  loading: boolean
  reason: 'changingPlan' | 'simpleDelete'
}

class OnBeforeDeleteClass extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      newerPlans: [],
      loading: true,
      reason: 'changingPlan'
    }
  }

  protected getPlanNameField(): string {
    const planFieldName = 'RegPlanId'
    return planFieldName
  }

  protected getOverridePlanNameField(): string {
    const planFieldName = 'OverriddenByRegPlanId'
    return planFieldName
  }

  componentDidMount() {
    const planId = this.props.feature.getProperties()[this.getPlanNameField()]
    const planInfo = this.props.layerInfos[appConfig.reg.plan.planUrl]
    ServiceHub.gisCrudService
      .execute(planInfo, {
        where: `"PlanDate" > (select "PlanDate" from reg."RegPlan" where "Id" = ${planId}) AND "Id" IN (SELECT "Id" FROM reg."RegPlan" WHERE "LocalityId" = ${
          this.props.feature.getProperties()['LocalityId']
        })`
      })
      .then(r => {
        this.setState({...this.state, newerPlans: r, loading: false})
      })
      .catch(e => {
        this.setState({...this.state, loading: false})
      })
  }

  getPlanSelector() {
    const options: JSX.Element[] = [<option key={'A'} value={''}></option>]
    this.state.newerPlans
      .filter(p => p.getProperties()['RegPlanTypeId'] == 2)
      .forEach((p, i) => {
        options.push(
          <option key={i} value={p.getProperties()['Id']}>
            {getPlanName(p)}
          </option>
        )
      })
    return (
      <div>
        <div>Изберете план на изменение</div>
        <select
          onChange={e => {
            const selectedNewerPlan = this.state.newerPlans.find(
              p => parseInt(p.getProperties()['Id']) == parseInt(e.target.value)
            )
            this.setState({...this.state, selectedNewerPlan})
          }}
          className="form-control"
          value={this.state.selectedNewerPlan ? this.state.selectedNewerPlan.getProperties()['Id'] : ''}
        >
          {options}
        </select>
      </div>
    )
  }

  getReasonSelector() {
    const options: JSX.Element[] = [
      <option key={'A'} value={'changingPlan'}>
        Приложено изменение
      </option>,
      <option key={'B'} value={'simpleDelete'}>
        Изтриване
      </option>
    ]

    return (
      <select
        onChange={e => {
          this.setState({...this.state, reason: e.target.value as any})
        }}
        className="form-control"
        value={this.state.reason}
      >
        {options}
      </select>
    )
  }

  render() {
    return (
      <div className="on-before-delete">
        <OverlayLoader show={this.state.loading}></OverlayLoader>
        <div>Изберете причина за изтриването</div>
        {this.getReasonSelector()}
        {this.state.reason == 'changingPlan' ? this.getPlanSelector() : null}
        <br></br>
        <button
          type="button"
          disabled={
            (this.state.reason == 'changingPlan' && !this.state.selectedNewerPlan) ||
            (this.state.reason == 'simpleDelete' && false)
          }
          className="button width"
          onClick={() => {
            const feat = this.props.feature.clone()
            feat.set(this.getPlanNameField(), 0)
            if (this.state.reason == 'changingPlan') {
              feat.set(this.getOverridePlanNameField(), parseInt(this.state.selectedNewerPlan!.getProperties()['Id']))
              this.props.continueDelete(feat)
            } else if (this.state.reason == 'simpleDelete') {
              feat.set(this.getOverridePlanNameField(), 0)
              this.props.continueDelete(feat)
            }
          }}
        >
          Потвърди изтриването
        </button>
      </div>
    )
  }
}

const mapStateToProps = (store: IAppStore) => ({
  layerInfos: store.layerInfos.featureLayerInfos
})

export const OnBeforeDelete = connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {})(OnBeforeDeleteClass)
